/* Flair product gallery - peek carousel. All PDP templates, mobile AND desktop.

   Built at runtime rather than in the product section files - there are seven
   of them (bundle-builder, refill-bundle, inhaler-product, earseeds-product,
   accessories-product, essential-oil-product, diffuser-product) and several
   are 40-108 KB, so editing each one whole is a far bigger risk than this.

   They all share .bundle-gallery-panel / .bundle-product-visual and a
   thumbnail container whose id ends in "Thumbs" (bundleThumbs, inhalerThumbs,
   earseedsThumbs, refillBundleThumbs, ...), so the selectors are generic.

   Structure built here:

     .flair-mgallery-wrap        <- position: relative, hugs the slide height
       .flair-mgallery           <- the scroll-snap track
         .flair-mgallery__slide
       .flair-mgallery-nav       <- absolute prev/next arrows, ON the image
       .flair-mgallery-dots      <- absolute, ON the image

   The arrows and dots go in the WRAPPER, never in .bundle-gallery-panel. The
   panel is taller than the carousel (stock badge and other chrome live there
   too), so anchoring to it puts them below the images instead of on them.

   No viewport gate: the carousel is built at every width and the two layouts
   are handled in CSS. Gating on matchMedia here would leave the desktop
   layout broken for anyone who resized across the breakpoint.

   IMPORTANT: slide 1 reuses the EXISTING main image element rather than a
   clone, so each template's variant-switching code - which sets
   #bundleMainImage.src, #inhalerMainImage.src etc - still updates the first
   slide. Do not change that to a clone. */
(function () {
  var CHEVRON_LEFT =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
  var CHEVRON_RIGHT =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>';

  function init() {
    var panel = document.querySelector('.bundle-gallery-panel');
    if (!panel || panel.dataset.mgallery === 'done') return;

    var visual = panel.querySelector('.bundle-product-visual');
    if (!visual) return;

    // Thumbnail sources - container id ends in "Thumbs" on every template,
    // with a *-thumb-link anchor class as a fallback.
    var thumbImgs = panel.querySelectorAll('[id$="Thumbs"] img');
    if (thumbImgs.length < 2) {
      thumbImgs = panel.querySelectorAll('a[class*="thumb-link"] img');
    }
    if (thumbImgs.length < 2) return; // single image, nothing to swipe

    // Wrapper first - this is what the arrows and dots are positioned against
    var wrap = document.createElement('div');
    wrap.className = 'flair-mgallery-wrap';
    var track = document.createElement('div');
    track.className = 'flair-mgallery';
    wrap.appendChild(track);

    // Slide 1: move the real main image in, don't copy it
    var first = document.createElement('div');
    first.className = 'flair-mgallery__slide';
    visual.parentNode.insertBefore(wrap, visual);
    first.appendChild(visual);
    track.appendChild(first);

    // Remaining slides from the thumbnail sources, upscaled to 800px
    for (var i = 1; i < thumbImgs.length; i++) {
      var src = thumbImgs[i].getAttribute('src') || '';
      var big = src.replace(/([?&]width=)\d+/, '$1800');
      var slide = document.createElement('div');
      slide.className = 'flair-mgallery__slide';
      var img = document.createElement('img');
      img.src = big;
      img.alt = thumbImgs[i].getAttribute('alt') || '';
      img.width = 800;
      img.height = 800;
      img.loading = 'lazy';
      img.decoding = 'async';
      slide.appendChild(img);
      track.appendChild(slide);
    }

    var slides = track.querySelectorAll('.flair-mgallery__slide');
    var current = 0;

    function goTo(index) {
      // wrap around, so next always does something on the last slide
      var n = slides.length;
      var target = ((index % n) + n) % n;
      var pad = window.innerWidth > 768 ? 28 : 16;
      track.scrollTo({ left: slides[target].offsetLeft - pad, behavior: 'smooth' });
    }

    // Prev / next arrows
    var nav = document.createElement('div');
    nav.className = 'flair-mgallery-nav';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'flair-mgallery-arrow flair-mgallery-arrow--prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = CHEVRON_LEFT;
    prev.addEventListener('click', function () {
      goTo(current - 1);
    });

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'flair-mgallery-arrow flair-mgallery-arrow--next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = CHEVRON_RIGHT;
    next.addEventListener('click', function () {
      goTo(current + 1);
    });

    nav.appendChild(prev);
    nav.appendChild(next);
    wrap.appendChild(nav);

    // Dots
    var dots = document.createElement('div');
    dots.className = 'flair-mgallery-dots';
    for (var d = 0; d < slides.length; d++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'flair-mgallery-dot' + (d === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Go to image ' + (d + 1));
      (function (index) {
        dot.addEventListener('click', function () {
          goTo(index);
        });
      })(d);
      dots.appendChild(dot);
    }
    wrap.appendChild(dots);

    // Active dot + current index follow the scroll position.
    // IntersectionObserver rather than a scroll handler so there are no layout
    // reads on every scroll event.
    var dotEls = dots.querySelectorAll('.flair-mgallery-dot');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var idx = Array.prototype.indexOf.call(slides, entry.target);
            if (idx < 0) return;
            current = idx;
            for (var k = 0; k < dotEls.length; k++) {
              dotEls[k].classList.toggle('is-active', k === idx);
            }
          });
        },
        { root: track, threshold: 0.6 }
      );
      for (var s = 0; s < slides.length; s++) io.observe(slides[s]);
    }

    // Keyboard support for the gallery
    track.setAttribute('tabindex', '0');
    track.setAttribute('role', 'region');
    track.setAttribute('aria-label', 'Product images');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        goTo(current + 1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goTo(current - 1);
      }
    });

    panel.dataset.mgallery = 'done';
    document.body.classList.add('flair-mgallery-active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
